import type { ArtikelauswahlClientImplementation } from "@/legacy/artikelauswahlClient";
import type { ArtikelauswahlApiResponse } from "@/lib/models/artikelauswahl";
import { WarenkorbTyp } from "@/lib/models/warenkorb";

const warenkorbTypSelectorMapping = {
	[WarenkorbTyp.Warenkorb]: "[data-cart-count]",
	[WarenkorbTyp.Anfragekorb]: "[data-basket-count]",
};

export class ArtikelauswahlInocon implements ArtikelauswahlClientImplementation {
	SetArtikelauswahlArtikelnummer(artikelNr: string) {
		let $artikelNr = $("#artikelnr .value__entry.value__entry--active");

		$artikelNr.text(artikelNr);
	}

	AktualisiereMengenAnzeige(warenkorbtyp: WarenkorbTyp, anzahlPositionen: number) {
		$(warenkorbTypSelectorMapping[warenkorbtyp])
			.text(anzahlPositionen.toString())
			.toggle(anzahlPositionen > 0);
	}

	SetArtikelauswahlNormblattBild(data: ArtikelauswahlApiResponse) {
		if (data.bildUrl == null) return;

		// @ts-ignore Fehlende Typedefs für swiper
		const swiper = $(".product-image-slider").find(".swiper-container")[0].swiper;
		if (swiper == null) return;

		const images = Array.from(swiper.slides.children());

		for (let i in images) {
			// @ts-ignore Fehlende Typedefs für swiper
			if (images[i].src == data.bildUrl) {
				swiper.slideTo(i);
				break;
			}
		}
	}
}
